import { render, staticRenderFns } from "./VehicleManufacturerForm.vue?vue&type=template&id=49130a9b"
import script from "./VehicleManufacturerForm.vue?vue&type=script&lang=js"
export * from "./VehicleManufacturerForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports